import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import ToolkitMenu from "components/ToolkitMenu";
import { showNativeNav } from "src/pods/webviewInit";
import { logParentToolkitEvent } from "src/utils/logEvent";

function Index() {
  const [params] = useSearchParams();
  const query = Object.fromEntries(params.entries());

  const isPremiumUnlocked = query.isPremiumUnlocked == "true";
  const variant = query.variant || "off";

  // eslint-disable-next-line @web-monorepo/require-useEffect-dependency-array
  useEffect(() => {
    logParentToolkitEvent({ eventName: `webview.viewed` });

    showNativeNav(true);
    return () => {
      showNativeNav(false);
    };
  });

  return <ToolkitMenu {...{ isPremiumUnlocked, variant }} />;
}

export default Index;
